import { SaveOutlined, CloudDownloadOutlined, LoadingOutlined, DeleteOutlined } from '@ant-design/icons'
import { Col, Row, List, Button, Spin, Modal } from 'antd'
import * as React from 'react'
import { Input } from 'antd'
import { TTFormItem } from '../shared/TTFormItem'
import { TTSelect } from '../shared/TTSelect'
import { RouteComponentProps, withRouter } from 'react-router'
import container from '../../wires/Bootstrapper'
import SERVICE_IDENTIFIER from '../../wires/Identifiers'
import { ConfigFattureModel } from '../../models/UtenteModels'
import { renderSelectKeyValue, renderSelectList, renderSelectModel } from '../shared/SelectOptionRenderUtils'
import { KeyValueModel } from '../../models/ModelBase'
import { IAppContext } from '../AppContext'
import { IConfigurazioneService } from '../../services/ConfigurazioneService'

interface TabConfigFattureProps {
    clienteId: string
}

class PageConfigFattureState extends ConfigFattureModel {
    isLoading: boolean
}

export class TabConfigFatture extends React.Component<TabConfigFattureProps, PageConfigFattureState> {
    service: IConfigurazioneService
    constructor(props) {
        super(props)
        this.service = container.get(SERVICE_IDENTIFIER.CONFIGURAZIONE_SERVICE)
        this.state = new PageConfigFattureState()
    }

    async componentDidMount() {
        this.loadConfig();
    }

    async loadConfig() {
        let resp = await this.service.GetConfigFatture(this.props.clienteId)
        this.setState(resp)
        this.setNrPeriodoList(resp.Periodo, resp.NrPeriodo)
        this.setState({ ...this.state, isLoading: false })
    }

    onSaveClick = async () => {
        this.setState({ ...this.state, isLoading: true })
        var resp = await this.service.SaveConfigFatture(this.state)
        if (resp.IsValid === true) {
            this.setState(resp)
            this.setNrPeriodoList(resp.Periodo, resp.NrPeriodo)

        }
        this.setState({ ...this.state, isLoading: false })
    }

    onDeleteClick = async () => {
        Modal.confirm({
            title: "Elimina configurazione",
            content: "Eliminare la configurazione?",
            onOk: async () => {
                let resp = await this.service.DeleteConfigFatture(this.props.clienteId)
                if (resp.IsValid == true)
                    this.loadConfig();
            }
        })
    }


    onImportClick = async () => {
        this.setState({ ...this.state, isLoading: true })
        var rs = await this.service.ImportConfigFatture(this.state)
        this.setState({ ...this.state, isLoading: false })
    }

    onPeriodoChange = (e: string) => {
        this.setNrPeriodoList(e)
    }

    private setNrPeriodoList(periodo: string, nrperiodo?: string) {
        let model = this.state
        let nrPeriodi = this.service.SetNrPeriodoList(periodo);

        if (nrperiodo == null || nrperiodo == "") nrperiodo = nrPeriodi[0]

        this.setState({ ...model, Periodo: periodo, NrPeriodoList: nrPeriodi, NrPeriodo: nrperiodo })
    }




    render() {
        return (
            <>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} spin />} spinning={this.state.isLoading}>
                    <Row>
                        <Col span={8}>
                            <Button disabled={this.state.IdApp == "" || this.state.IdApp == null } type="default" key="save" icon={<CloudDownloadOutlined />} onClick={() => this.onImportClick()}>Importa</Button>

                        </Col>
                        <Col span={2} offset={12}>
                            <Button disabled={this.state.IdApp == "" || this.state.IdApp == null} type="default" style={{ float: 'right' }} key="delete" icon={<DeleteOutlined />} onClick={() => this.onDeleteClick()}>Delete</Button>
                        </Col>
                        <Col span={2}>
                            <Button type="primary" style={{ float: 'right' }} key="save" icon={<SaveOutlined />} onClick={() => this.onSaveClick()}>Salva</Button>
                        </Col>
                    </Row>
                    <TTFormItem label="Connettore" required={true}>
                        <TTSelect size="small" value={this.state.Connettore} onChange={e => this.setState({ Connettore : e as string }) }>
                            {renderSelectKeyValue(this.state.ConnettoreList)}
                        </TTSelect>
                    </TTFormItem>
                    <hr />
                    <br />
                    <Row>
                        <Col span={12}>
                            <TTFormItem label="App ID" required={true} >
                                <Input value={this.state.IdApp} onChange={e => this.setState({ IdApp: e.target.value })} />
                            </TTFormItem>
                            <TTFormItem label="Periodo" required={true}>
                                <TTSelect size="small" value={this.state.Periodo} onChange={e => this.onPeriodoChange(e as string)}>
                                    {renderSelectKeyValue(this.state.PeriodoList)}
                                </TTSelect>
                            </TTFormItem>
                        </Col>
                        <Col span={12}>
                            <TTFormItem label="Key ID" required={true} >
                                <Input value={this.state.KeyApp} onChange={e => this.setState({ KeyApp: e.target.value })} />
                            </TTFormItem>
                            <TTFormItem label="Nr Periodi" required={true}>
                                <TTSelect size="small" value={this.state.NrPeriodo} onChange={e => this.setState({ NrPeriodo: e as string })}>
                                    {renderSelectList(this.state.NrPeriodoList)}
                                </TTSelect>
                            </TTFormItem>
                        </Col>
                    </Row>
                </Spin>
            </>
        )
    }
}

//export const TabConfigFatture = withRouter(TabConfigFattureComp)